<template>
  <div class="rs-form-checkbox-search">
    <div
      v-if="isSearchable"
      class="mt-3 d-flex flex-row justify-content-between"
    >
      <RsFormInput
        v-model="searchText"
        icon="search"
        :debounce="300"
        type="search"
        :placeholder="placeholder"
      />
      <div class="d-flex">
        <RsButton
          variant="secondary"
          hollow
          @click="handleSelectAll(true)"
        >
          {{ $ts('actions.selectAll') }}
        </RsButton>
        <RsButton
          variant="secondary"
          class="rs-modal-btn-secondary-margin"
          hollow
          @click="handleSelectAll(false)"
        >
          {{ $ts('actions.deselectAll') }}
        </RsButton>
      </div>
    </div>
    <div>
      <OverlayScrollbars
        ref="scrollbar"
        :options="{ sizeAutoCapable: false }"
        class="rs-scroll"
        :style="{ height: `160px` }"
      >
        <RsCheckboxGroup
          :id="rsCheckboxGroupId"
          :key="value.length"
          :columns="columns"
          :selected="value"
          :options="searchResults"
          @change="$emit('input', $event)"
        />
      </OverlayScrollbars>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import RsFormInput from '@/components/_global/RsFormInput.vue';
import { ISelectOption } from '@/shared';

interface ICheckboxSearchState {
  searchText: string,
}

export default defineComponent({
  name: 'RsFormCheckboxSearch',

  components: { RsFormInput },

  props: {
    options: {
      type: Array as () => ISelectOption[],
      default: () => [],
    },
    value: {
      type: Array as () => string[] | number[],
      default: () => [],
    },
    columns: {
      type: Number,
      default: 2,
    },
    rsCheckboxGroupId: {
      type: String,
      default: '',
    },
    isSearchable: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },

  data(): ICheckboxSearchState {
    return {
      searchText: '',
    };
  },

  computed: {
    searchResults(): ISelectOption[] {
      return this.options?.filter((option) => option.text.toLowerCase().includes(this.searchText.toLowerCase())) || [];
    },
  },

  methods: {
    handleSelectAll(isAll: boolean) {
      const selectedOptions = (this.options.length && isAll) ? this.options.map((city: ISelectOption) => city.value) : [];
      this.$emit('input', selectedOptions);
    },
  },
});

</script>

<style lang="scss">

.rs-form-checkbox-search {
  .rs-checkbox {
    margin-bottom: 3px !important;
  }
}

</style>
